export default __webpack_public_path__ + "static/media/PAGE NOT FOUND.e6b4ee2f.gif";